import { autoinject, LogManager } from 'aurelia-framework';
import { TenantRepository } from "data/service/tenant-repository";
import { DirectoryService } from "data/service/directory-service";
import { EntityManager } from 'aurelia-orm';
import { Tenant } from "data/entities/entities";
import { ValidationController } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'core/bootstrap-form-renderer';
import { EventAggregator } from 'aurelia-event-aggregator';
import { AppEvents } from 'core/app-events';
import { DirectoryInfo } from 'data/entities/directory-info';
import { Router } from 'aurelia-router';

@autoinject()
export class CreateTeam {
	alertMessage: string;
	hasMessage: boolean;
	isErrorMessage: boolean;
	isClickble: boolean;
	logger = LogManager.getLogger('CreateTeam');
	repository: TenantRepository;
	tenant: Tenant;
	items: Array<DirectoryInfo>;

	constructor(
		private entityManager: EntityManager,
		private directoryService: DirectoryService,
		private validationController: ValidationController,
		private eventAggregator: EventAggregator,
		private router: Router,
		private bootstrapFormRenderer: BootstrapFormRenderer) {
		this.repository = this.entityManager.getRepository(Tenant);
		this.initializeTenant();
		this.validationController.addRenderer(bootstrapFormRenderer);
	}

	initializeTenant() {
		this.tenant = this.repository.getNewEntity();
	}

	cancelTenant() {
		this.clearAlertMessage();
		this.validationController.reset();
		this.initializeTenant();
	}

	clearAlertMessage() {
		this.hasMessage = false;
		this.alertMessage = null;
		this.isErrorMessage = false;
	}

	setAlertMessage(message: string, isError: boolean) {
		this.isErrorMessage = isError;
		this.alertMessage = message;
		this.hasMessage = true;
	}

	redirectBack() {
		this.router.navigateToRoute('team');
	}

	async processTenant() {
		const result = await this.validationController.validate();
		if (result.valid) {
			// validation succeeded
			this.submitTenant();
		} else {
			console.log("failure");
			// validation failed
		}
	}

	async submitTenant() {
		try {
			$("#saveButton").attr("disabled", "true");
			$("#clearButton").attr("disabled", "true");
			const duplicateName = await this.repository.checkForDuplicateTeam(this.tenant.name);
			if (!duplicateName) {
				this.tenant.createdOn = new Date();
				await this.tenant.save();
				this.setAlertMessage("Successfully created new Team called " + this.tenant.name, false);
				this.initializeTenant();
				this.eventAggregator.publish(AppEvents.DIRECTORY_ADDED);
			}
			else {
				this.setAlertMessage("Team name should not duplicate.", true);
			}
			$("#saveButton").removeAttr("disabled");
			$("#clearButton").removeAttr("disabled");
		}
		catch (error) {
			this.setAlertMessage(error, true);
		}
	}
}
